<template>
  <div id="app">
    <div class="preloader">
      <div class="ll"><img src="./assets/logob.svg" class="puff-out-center" /></div>
    <svg width="100%" height="100%" viewBox="0 0 2153 566" version="1.1" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/"
      style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;">
      <g transform="matrix(1,0,0,1,-3996.12,-257.015)">
        <g transform="matrix(1,0,0,0.333345,105.505,0)">
          <g transform="matrix(1,0,0,2.99989,-237.449,233.783)">
            <path class="path"
              d="M4145.87,692.187C4190.5,647.552 4277.79,640.624 4346.83,647.528C4380.04,650.849 4414,658.522 4448.33,653.618C4496.88,646.682 4544.2,638.576 4590.42,623.169C4641.59,606.113 4679.06,561.09 4695.98,509.494C4701.23,493.476 4714.29,414.043 4720.34,407.998C4726.08,402.257 4785.2,412.058 4795.44,412.058C4797.58,412.058 4801.53,410.028 4801.53,410.028L4801.53,418.148C4801.53,425.935 4803.25,447.182 4799.5,454.686C4792.53,468.623 4795.32,539.817 4807.62,552.122C4877.72,622.216 4939.5,658.366 5053.24,639.409C5069.13,636.761 5082.12,623.693 5095.87,619.11C5197.01,585.395 5179.1,423.084 5179.1,334.921C5179.1,304.662 5181.28,273.053 5177.07,243.575C5175.3,231.214 5174.84,216.59 5170.98,205.007C5170.1,202.36 5168.95,196.887 5168.95,196.887C5168.95,196.887 5172.28,203.043 5175.04,205.007C5190.68,216.15 5206.37,227.106 5227.81,231.395C5257.01,237.234 5294.42,228.141 5321.19,219.216C5323.19,218.551 5331.28,211.038 5333.37,213.126C5334.03,213.789 5336.41,289.243 5337.43,296.353C5345.53,353.082 5368.79,411.855 5394.27,462.806C5408.01,490.294 5506.18,545.679 5534.33,564.302C5580.38,594.766 5629,632.557 5680.49,653.618C5865.81,729.434 6065.63,735.793 6263.07,720.605"
              style="fill:none;stroke:rgb(17,166,194);stroke-opacity:0.1;stroke-width:30px;" />
          </g>
        </g>
      </g>
    </svg>
    </div>
    <div class="logomain" :class="{dark: dark}">
      <img src="./assets/logomini.svg"  />
    </div>
    <div class="indicator is-hidden-mobile" :class="{dark: dark}">
      <ul>
        <li v-for="slide in slides" :key="slide.title" @click="gotoslide(slide.id)" :class="{active: active == slide.id}">
          <div class="columns is-mobile is-variable is-2">
            <div class="column"></div>
            <div class="column is-narrow">{{slide.title}}</div>
            <div class="column is-narrow">●</div>
          </div>
        </li>
        
      </ul>
    </div>
    <div class="indicatorm is-hidden-tablet" :class="{dark: dark}">
      <div class="columns is-mobile is-centered">
        <div class="column cl is-one-quarter has-text-centered" v-for="slide in slides" :key="slide.title" @click="gotoslide(slide.id)" :class="{active: active == slide.id}">
          ●<br>
          {{slide.title}}
        </div>
    
      </div>
    </div>
    <vue-scroll-snap>
      <div class="item" id="slide-0">
        <WelcomePage @slideto="gotoslide(1)"></WelcomePage>
      </div>
      <div class="item" id="slide-1">
        <AboutSOS :active="slide1active"></AboutSOS>
      </div>
      <div class="item" id="slide-2">
        <ContactPage :active="slide2active"></ContactPage>
      </div>
    </vue-scroll-snap>

  </div>
</template>

<script>
  import WelcomePage from "./components/WelcomePage.vue";
  import ContactPage from "./components/ContactPage.vue";
  import AboutSOS from "./components/AboutSOS.vue";
  import VueScrollSnap from "vue-scroll-snap";
  export default {
    name: 'App',
    components: {
      WelcomePage,
      ContactPage,
      AboutSOS,
      VueScrollSnap
    },
    mounted() {
      window.addEventListener("scroll", this.onScroll, true)
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.onScroll, true)
    },
    methods: {
      gotoslide(which){
        const element = document.getElementById("slide-"+which);
        element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
      },
      onScroll(e) {
        let scroll = e.target.scrollTop;
        let height = window.innerHeight;
        if(scroll > (height - (height/2)) && scroll < (height * 2))
        {
          this.active = 1;
          this.slide1active = true;
        }
        if (scroll > (height + height/2) ) {
          this.active = 2;
          this.slide2active = true;

        }
        if (scroll < (height - (height / 2))) {
          this.active = 0;
        }
        this.dark = this.slides[this.active].dark;
        console.log(e.target.scrollTop);
      }
    },
    data() {
      return {
        windowTop: 0,
        slide1active: false,
        slide2active: false,
        dark: false,
        active: 0,
        slides: [
          {
            id: 0,
            title: "Vítejte",
            dark: false
          },
          {
            id: 1,
            title: "SOS Lékárna",
            dark: true
          },
          {
            id: 2,
            title: "Kontakt",
            dark: true
          },
        ]
      }
    }
  }
</script>

<style>
html,
  body {
    margin: 0;
    padding: 0;
  }
        .path {
          stroke-dasharray: 5000;
          stroke-dashoffset: 5000;
          animation: dash 5s ease forwards;
        }
    
        @keyframes dash {
          to {
            stroke-dashoffset: 0;
          }
        }
.preloader
{
  background-color: white;
  position: absolute;
  width: 100vw;
  height: 100vh;-webkit-animation: scale-out-center 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
    animation: scale-out-center 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
  animation-delay: 2300ms;
    z-index: 9400;
}
.preloader img {
  -webkit-animation: puff-out-center 1s cubic-bezier(0.165, 0.840, 0.440, 1.000) both;
  animation: puff-out-center 1s cubic-bezier(0.165, 0.840, 0.440, 1.000) both;
  animation-delay: 1600ms;
}
/* ----------------------------------------------
 * Generated by Animista on 2022-10-9 15:20:54
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation scale-out-center
 * ----------------------------------------
 */
@-webkit-keyframes scale-out-center {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }

  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
}

@keyframes scale-out-center {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    opacity: 1;
  }

  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
}
.preloader .ll {
  width: 200px;height: 300px;
  position: absolute;
    -webkit-animation: tilt-in-fwd-bl 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
      animation: tilt-in-fwd-bl 0.6s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
  .item {
    min-height: 100vh;
  }
  .indicator {
    position: absolute;
    color: white;
    transition: all 0.6s ease;
    right: 80px;
    display: flex;
    height: 100%;
    z-index:9001;
    cursor: pointer;
    flex-direction: column;
    justify-content: center;
  }
  .indicatorm{
    position: absolute;
    color: white;
    transition: all 0.6s ease;
    bottom: 20px;
    width: 100%;
    z-index: 9005;
    cursor: pointer;
  }
    /* ----------------------------------------------
   * Generated by Animista on 2022-10-9 15:14:50
   * Licensed under FreeBSD License.
   * See http://animista.net/license for more info. 
   * w: http://animista.net, t: @cssanimista
   * ---------------------------------------------- */
  
    /**
   * ----------------------------------------
   * animation tilt-in-fwd-bl
   * ----------------------------------------
   */
    @-webkit-keyframes tilt-in-fwd-bl {
      0% {
        -webkit-transform: rotateY(-20deg) rotateX(-35deg) translate(-300px, 300px) scale(0.5) skew(-35deg, 10deg);
        transform: rotateY(-20deg) rotateX(-35deg) translate(-300px, 300px) scale(0.5) skew(-35deg, 10deg);
        opacity: 0;
      }
  
      100% {
        -webkit-transform: rotateY(0) rotateX(0deg) translate(-50%, -50%) scale(1) skew(0deg, 0deg);
        transform: rotateY(0) rotateX(0deg) translate(-50%, -50%) scale(1) skew(0deg, 0deg);
        opacity: 1;
      }
    }
  
    @keyframes tilt-in-fwd-bl {
      0% {
        -webkit-transform: rotateY(-20deg) rotateX(-35deg) translate(-300px, 300px) scale(0.5) skew(-35deg, 10deg);
        transform: rotateY(-20deg) rotateX(-35deg) translate(-50%, -50%) scale(0.5) skew(-35deg, 10deg);
        opacity: 0;
      }
  
      100% {
        -webkit-transform: rotateY(0) rotateX(0deg) translate(-50%, -50%) scale(1) skew(0deg, 0deg);
        transform: rotateY(0) rotateX(0deg) translate(-50%, -50%) scale(1) skew(0deg, 0deg);
        opacity: 1;
      }
    }
        /* ----------------------------------------------
     * Generated by Animista on 2022-10-9 15:16:33
     * Licensed under FreeBSD License.
     * See http://animista.net/license for more info. 
     * w: http://animista.net, t: @cssanimista
     * ---------------------------------------------- */
    
        /**
     * ----------------------------------------
     * animation puff-out-center
     * ----------------------------------------
     */
        @-webkit-keyframes puff-out-center {
          0% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-filter: blur(0px);
            filter: blur(0px);
            opacity: 1;
          }
    
          100% {
            -webkit-transform: scale(2);
            transform: scale(2);
            -webkit-filter: blur(4px);
            filter: blur(4px);
            opacity: 0;
          }
        }
    
        @keyframes puff-out-center {
          0% {
            -webkit-transform: scale(1);
            transform: scale(1);
            -webkit-filter: blur(0px);
            filter: blur(0px);
            opacity: 1;
          }
    
          100% {
            -webkit-transform: scale(2);
            transform: scale(2);
            -webkit-filter: blur(4px);
            filter: blur(4px);
            opacity: 0;
          }
        }
  .indicator.dark, .indicatorm.dark
   {
    color: black;
   }
  .indicator li:not(.active),.indicatorm .cl:not(.active)
  {
    opacity: 0.5;
    transition: all 0.6s ease;
  }
  .indicator li
  {
    transition: all 0.6s ease;
  }
  .indicator li:hover
  {
    opacity: 0.8;
    transition: all 0.6s ease;
  }
  .logomain {
    position: fixed;
    z-index: 9000;
    height: 300px;
    width: 300px;
    mix-blend-mode: overlay;
    filter: invert(1);
    right: -30px;
    transition: all 0.6s ease;
    opacity: 50%;
    bottom: 0px;
    pointer-events:none;
  }
  .logomain.dark
  {
    filter: invert(0);
  }

  .scroll-snap-container {
    height: 100vh;
    width: 100vw;
  }

  .slide {
    width: 100vw;
    height: 100vh;
  }

  @media screen and (max-width: 768px)
  {
    
    html, body, .app {
      overflow-x: hidden;
      max-width: 100%;
      min-width: 1167px; 
      -webkit-overflow-scrolling: auto;
        /* Stops scrolling immediately */
    }
    .logomain {
      opacity: 20%;
      height: 200px;
      width: 200px;
    }
  }

  /* ----------------------------------------------
 * Generated by Animista on 2022-10-8 23:59:20
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

  /**
 * ----------------------------------------
 * animation fade-in-bottom
 * ----------------------------------------
 */
  @-webkit-keyframes fade-in-bottom {
    0% {
      -webkit-transform: translateY(50px);
      transform: translateY(50px);
      opacity: 0;
    }

    100% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes fade-in-bottom {
    0% {
      -webkit-transform: translateY(50px);
      transform: translateY(50px);
      opacity: 0;
    }

    100% {
      -webkit-transform: translateY(0);
      transform: translateY(0);
      opacity: 1;
    }
  }

  /* ----------------------------------------------
 * Generated by Animista on 2022-10-8 23:42:48
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

  /**
 * ----------------------------------------
 * animation bg-pan-left
 * ----------------------------------------
 */
  @-webkit-keyframes bg-pan-left {
    0% {
      background-position: 100% 50%;
    }

    100% {
      background-position: 0% 50%;
    }
  }

  @keyframes bg-pan-left {
    0% {
      background-position: 100% 50%;
    }

    100% {
      background-position: 0% 50%;
    }
  }

  /* ----------------------------------------------
 * Generated by Animista on 2022-10-8 23:57:33
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

  /**
 * ----------------------------------------
 * animation tracking-in-expand
 * ----------------------------------------
 */
  @-webkit-keyframes tracking-in-expand {
    0% {
      letter-spacing: -0.5em;
      opacity: 0;
    }

    40% {
      opacity: 0.6;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes tracking-in-expand {
    0% {
      letter-spacing: -0.5em;
      opacity: 0;
    }

    40% {
      opacity: 0.6;
    }

    100% {
      opacity: 1;
    }
  }
</style>